import { adapters, RpcRequest } from '@dealroadshow/json-rpc-dispatcher';
import { PageRenderingState, PageRenderingStateValue } from '@framework/di';
import Container from '@framework/di/Container';
import ClientReqData from '@framework/router/Next/headers/ClientReqData';

type FetchOptions = NonNullable<ConstructorParameters<typeof adapters.Fetch>[1]>;

interface IHeadersSupportingFetchOptions extends FetchOptions {
  container: Container,
}

class AsyncHeadersSupportingFetchAdapter extends adapters.Fetch {
  private readonly container: Container;

  constructor(url: string = '/', options: IHeadersSupportingFetchOptions) {
    const { container, ...restOptions } = options;
    super(url, restOptions);
    this.container = container;
  }

  async call(request: RpcRequest, options: RequestInit): Promise<string> {
    await this.addHeaders();
    return super.call(request, options);
  }

  async addHeaders() {
    const pageRenderingState = this.container.get<PageRenderingStateValue>(PageRenderingState);
    if (pageRenderingState === PageRenderingStateValue.ServerSideRendering) {
      await this.addHeadersOnServerSide();
    }
  }

  async addHeadersOnServerSide() {
    const { ssrHeaders } = await this.container.getAsync<ClientReqData>(ClientReqData);
    const mergedHeaders = new Headers(this.options.headers);

    ssrHeaders.forEach((value, key) => {
      mergedHeaders.set(key, value);
    });

    this.options.headers = mergedHeaders;
  }
}

export default AsyncHeadersSupportingFetchAdapter;
